import script from "./TutorialQuickAsk.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialQuickAsk.vue?vue&type=script&setup=true&lang=js"

import "./TutorialQuickAsk.vue?vue&type=style&index=0&id=412a3886&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412a3886"]])

export default __exports__